import { datadogRum, User } from '@datadog/browser-rum';

const beforeSend = (event, context) => {
  if (event.type === 'error') {
    if (
      event.error.message.includes('This Suspense boundary received an update') ||
      event.error.message.includes('Minified React error #421') ||
      event.error.message.includes('Warning')
    ) {
      return false;
    }
    return true;
  }
  return true;
};

const datadogInit = (env, clientToken, proxyUrl) => {
  datadogRum.init({
    beforeSend,
    applicationId: '1073c55e-6338-4e54-bf19-57168d08028d',
    clientToken,
    site: 'datadoghq.com',
    service: 'remix-console',
    env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    proxy: (options) => `${proxyUrl}${options.path}?${options.parameters}`,
  });
};

export default datadogInit;

export const datadogIdentify = (userProperties: User) => {
  datadogRum.setUser(userProperties);
};

export const clearDatadogUser = () => {
  datadogRum.clearUser();
  datadogRum.stopSession();
};
